import email from '../assets/email.webp';
import mobile from '../assets/mobile.webp';
import node from '../assets/node.webp';
import react from '../assets/react.webp';
import redux from '../assets/redux.webp';
import profile from '../assets/profile.webp';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.webp';

const images = {
  email,
  mobile,
  node,
  react,
  redux,
  profile,
  circle,
  logo,
};

export default images